import { LabelTemplateDetailDto, LabelTemplateEditDto } from './labelTemplate';

export const mapLabelTemplateDetailToEdit = (
  dto: LabelTemplateDetailDto
): LabelTemplateEditDto => ({
  id: dto.id,
  no: dto.no,
  name: dto.name,
  active: dto.active,
  description: dto.description
});
